import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { getLanguageCookie } from 'src/assets/language';
import { Subscription } from 'rxjs';
import { systemPermissionsNew } from 'src/app/helpers/systemPermissions';
import { addAlert, apiOfflineAsync } from "../../layouts/pages/pages.component";
import { TreeNode } from 'primeng/api';
import { v4 } from 'uuid';
import { PersonasService } from "../../services/personas/personas.service";
import { parse, stringify } from "circular-json";
import { sortArrayOfObjects } from 'src/app/helpers/sortArrayOfObjects';
import { UserEnvironmentsService } from 'src/app/services/userEnvironments/user-environments.service';
import { filterArraySubstringTree } from 'src/app/helpers/filterArraySubstringTree';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { to64decode } from 'src/app/helpers/base64';

interface CustomTreeNode extends TreeNode {
  uuid?: string;
  data?: any;
  children?: CustomTreeNode[];
  master?: string;
}

@Component({
  selector: 'app-personas',
  templateUrl: './personas.component.html',
  styleUrls: ['./personas.component.scss']
})
export class PersonasComponent {
  @Input() parameters: any = {}
  private subscription: Subscription = new Subscription();

  files!: CustomTreeNode[];
  filesOld!: CustomTreeNode[]

  queueAlert: any = []
  queueTime: any = []

  openTree: boolean = false;

  properties: any = {}

  selectedFlag: any = {
    lang: 'en',
    file: 'us.svg'
  };

  personas: any = {}
  formData: any

  isShow: boolean = false;
  isShowEdit: boolean = false;
  isShowDelete: boolean = false;

  isEdited = false;
  noData = true;

  isLoading: boolean = false;
  selectedNode: any;
  isSelectedNode = false;
  searchText: string = '';
  text: string = '';

  objectModal: any = {}

  data: any
  selectedFile: any;

  corporationPersonasArray: any = []
  searchCorporationPersonas: string = ''
  selectedCorporationPeronas: any = {
    name: '',
    uuid: ''
  }

  flagImportedTree: boolean = false

  filterArray: any = []
  filterCursor: number = 0
  isSearch: boolean = false

  isShowImport: boolean = false
  validateAllEntitysErrors: string = ''
  isShowChooseReference: boolean = false
  referenceTreeShared: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private personasService: PersonasService,
    private userEnvironmentService: UserEnvironmentsService,
    private localStorageService: LocalStorageService
  ) {

  }

  async ngOnInit() {
    this.properties = await this.localStorageService.localStorageToJsonAsync();
    await this.getPersonasTree();
    this.updateFiles({}, true);
    await this.getUserCorporations();
  }

  async toggleUpload() {
    this.isShowImport = !this.isShowImport;
    this.text = ''

    if(!this.isShowImport && this.filesOld !== this.files){
      this.files = this.filesOld
    }
  }

  async toggleUploadChooseReference(event?: Event) {
    this.isShowChooseReference = !this.isShowChooseReference;

    if(!this.isShowChooseReference && event != undefined){
      try {
        const response: any = await this.personasService.setPersonasReference({
          environment: this.properties.environment.uuid,
          corporation: this.properties.corporation.uuid,
          reference_uuid: event
        });
        
        if (response && response.status === 201) {
          addAlert('success', response.message);
          await this.getPersonasTree();
        }
      } catch (error) {
        addAlert('danger', 'Erro ao atualizar referência de personas');
      }
    }
  }

  async getUserCorporations() {
    try {
      let response = await this.userEnvironmentService.getUserCorporations()
      if (response && response.data) {
        this.corporationPersonasArray = sortArrayOfObjects([...response.data.filter((item: any) => item?.uuid != this.properties?.corporation?.uuid)]);
      }
    } catch {

    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getLanguages(file: string) {
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  async choseItemSelect(type: string, value: any) {
    switch (type) {
      case 'corporationPersona':
        this.selectedCorporationPeronas = value;
        this.isEdited = true
        await this.getPersonasTree()
        break;
    }
  }

  async getPersonasTree() {
    this.noData = false
    this.isLoading = true;

    try {
      const response: any = await this.personasService.getPersonasTree({ ...this.parameters, corporation_uuid: this.selectedCorporationPeronas.uuid }).toPromise();
      this.isLoading = false;
      if (response && response.data) {
        this.personas = parse(response.data)
        this.isShowImport = false
        if (this.selectedCorporationPeronas.uuid) {
          delete this.selectedCorporationPeronas
          delete this.personas.uuid
        }
        this.referenceTreeShared = this.personas.reference_tree_shared ?? false
        this.files = this.personas.json;
        this.filesOld = this.personas.json;

        this.isLoading = false;
        this.noData = this.files?.length == 0
        await this.flipTree()
      } else {
        throw new Error('Erro ao consultar àrvore de personas!\nConsulte o administrador do sistema!');
      }
    } catch (error: any) {
      await apiOfflineAsync(error)
    }
  }

  searchNodes(): void {
    this.filterCursor = 0;
    this.isSearch = true
    this.filterArray = filterArraySubstringTree(this.files, this.text)
    this.next()
  }

  next() {
    if (this.filterCursor < this.filterArray?.length) {
      this.filterCursor++;
      this.scrollToNode(this.filterArray[this.filterCursor - 1]);
    }
  }

  previous() {
    if (this.filterCursor > 1) {
      this.filterCursor--;
      this.scrollToNode(this.filterArray[this.filterCursor - 1]);
    }
  }

  scrollToNode(uuid: string) {
    const node = this.findNodeByUUID(this.files, uuid); // Procura o nó na árvore
    if (node) {
      this.selectedFile = node; // Define o nó selecionado
      this.expandParentNodes(node); // Expande os nós pais, se necessário

      setTimeout(() => {
        const element = document.getElementById(uuid);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 0)
    }
  }

  // Função para expandir todos os nós pais para garantir que o nó esteja visível
  expandParentNodes(node: any) {
    let parentNode = this.findNodeByUUID(this.files, node.master); // Encontra o pai usando `master`
    while (parentNode) {
      parentNode.expanded = true;  // Expande o nó pai
      parentNode = this.findNodeByUUID(this.files, parentNode.master); // Move para o próximo nó pai
    }
  }

  // Função recursiva para encontrar um nó pelo UUID na árvore
  findNodeByUUID(nodes: any[], uuid: string): any {
    for (let node of nodes) {
      if (node.uuid === uuid) {
        return node;
      }
      if (node.children) {
        const found = this.findNodeByUUID(node.children, uuid);
        if (found) return found;
      }
    }
    return null;
  }

  clearFilter(){
    this.isSearch = false; 
    this.filterArray = [];
    this.text = ''
  }

  verifyNoData() {
    if (this.files?.length == 0) {
      this.noData = true;
      return
    }
    this.noData = false;
  }

  private filterNode(node: TreeNode, query: string, includeParents: boolean = false): boolean {
    if (!node.label) {
      return false
    }
    const labelMatches = node.label.toLowerCase().includes(query.toLowerCase());

    if (labelMatches) {
      return true;
    }

    if (node.children) {
      const anyChildMatches = node.children.some((child) => this.filterNode(child, query, true));

      if (anyChildMatches) {
        return true;
      }
    }

    return false;
  }


  async flipTree() {
    this.openTree = !this.openTree;
    if (this.openTree) {
      return this.expandAll()
    }
    return this.collapseAll()
  }

  async expandAll() {
    this.files.forEach((node) => {
      this.expandRecursive(node, true);
    });
  }

  async collapseAll() {
    if (!this.files || !this.files?.length) {
      return
    }
    this.files.forEach((node) => {
      this.expandRecursive(node, false);
    });
  }

  expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach((childNode) => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  async loadModal(type: number, node: any = {}, event?: Event) {
    this.isShowEdit = false;
    this.isShow = false;

    if (type == 0) {
      this.selectedFile = null
      return
    } else if (type == 1) {
      await this.showCreateItemModal(node, event)
      return
    } else if (type == 2) {
      if (!this.getSystemPermission('organizational_structure', 'view')) {
        return
      }
      node = this.selectedFile
      await this.showEditItemModal(node)
      return
    } else if (type == 3) {
      await this.showDeleteItemModal(node)
      return
    }
  }

  setUpdateTreeItem(uuid: number, node: any) {
    this.files.forEach((item: any, index: number) => {
      if (uuid == item.uuid) {
        this.files[index] = node
      } else if (item.children?.length > 0) {
        this.setUpdateTreeItemRecursive(item.children, uuid, node)
      }
    })
  }

  setUpdateTreeItemRecursive(array: any, uuid: number, node: any) {
    array.forEach((item: any, index: number) => {
      if (uuid == item.uuid) {
        array[index] = node
      } else if (item.children?.length > 0) {
        this.setUpdateTreeItemRecursive(item.children, uuid, node)
      }
    })
  }

  async showCreateItemModal(node: any = {}, event?: Event) {
    if (event) {
      event.stopPropagation()
    }
    this.selectedFile = node

    this.cdr.detectChanges();
    this.parameters.isEdit = true;
    this.parameters.isCreate = true
    this.parameters.item = { uuid: v4() }
    this.parameters.item.master = this.selectedFile.uuid ?? 'ROOT'
    this.parameters.item.label = ''
    this.parameters.item.data = { cost: '' }
    this.parameters.item.rows = {}
    this.parameters.item.columns = {}
    this.parameters.isCreate = true

    this.isShow = true;
    this.objectModal = { ...this.parameters }
    this.objectModal.is_new = true;
    this.objectModal.personas = [...this.filesOld]
  }

  async showEditItemModal(node: any = {}, event?: Event) {
    if (!node) {
      return;
    }

    this.cdr.detectChanges();
    this.parameters.item = { ...node }
    delete this.parameters.item.children
    delete this.parameters.item.parent
    this.parameters.item = JSON.parse(JSON.stringify({ ...this.parameters.item }));
    if (!this.parameters.item.rows) this.parameters.item.rows = {}
    if (!this.parameters.item.rows.skills) this.parameters.item.rows.skills = []
    this.parameters.isCreate = false
    this.parameters.isEdit = false

    delete this.parameters.item.parent
    delete this.parameters.item.children

    this.objectModal = { ...this.parameters }
    this.objectModal.personas = this.filesOld
    this.objectModal.formData = this.formData
    this.isShowEdit = true;
  }

  async showDeleteItemModal(node: any = {}, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    this.isShowEdit = false;
    this.isShow = false;

    this.parameters.item = { ...node }
    this.objectModal = { ...this.parameters }
    this.objectModal.files = this.files
    this.objectModal.filesOld = this.filesOld

    if (!node || !node.data) {
      this.openCloseModalDelete(false)
      return
    }
    this.openCloseModalDelete(true)
  }

  openCloseModalDelete(option: boolean = true) {
    this.isShowDelete = option;
  }

  updateFiles(event?: any, ngOnInit?: boolean) {
    this.text = '';


    if (!ngOnInit) {
      this.isEdited = true;
    }

    if (event) {
      if (event.files) {
        this.files = event.files;
        this.filesOld = event.filesOld ?? event.files;
      }
      if (event.isShow) {
        this.isShow = event.isShow;
      }
    }

    this.verifyNoData();
    this.noData = this.files?.length == 0;

    this.files?.sort((a: any, b: any) => {
      if (a.data.type !== 'organogram' && b.data.type == 'organogram') {
        return -1;
      } else if (a.data.type !== 'organogram' && b.data.type == 'organogram') {
        return 1;
      } else {
        return 0;
      }
    });

    this.files?.forEach((item: any) => {
      this.recursiveUpdateSize(item);
    });

        
    this.formData = event.formData ? event.formData : new FormData()
    this.formData.append('json', stringify(this.filesOld))

    // for (const key of this.formData.keys()) {
    //   console.log(key, this.formData.get(key));
    // }
  }

  recursiveUpdateSize(item: any) {
    if (item.children && item.children?.length > 0) {

      item.children?.sort((a: any, b: any) => {
        if (a.data.type !== 'organogram' && b.data.type == 'organogram') {
          return -1;
        } else if (a.data.type !== 'organogram' && b.data.type == 'organogram') {
          return 1;
        } else {
          return 0;
        }
      });

      item.size = item.children?.reduce((acc: number, child: any) => {
        return acc + this.recursiveUpdateSize(child);
      }, 0);
    } else {
      item.size = 0;
    }
    return item.size + 1;
  }

  getSystemPermission(screen: string, action: string) {
    return systemPermissionsNew(screen, action)
  }

  async validateAllEntitys(children: any){
    for(let child of children){
      delete child.error //isso aqui muda o valor de this.files?
      this.cdr.detectChanges()
      if(child.data?.type == 'persona' && child.children?.length > 0){
        child.error = 'PersonaWithChildren'
        this.cdr.detectChanges()
        this.validateAllEntitysErrors = 'PersonaWithChildren'
      }

      // if(child.data?.type == 'persona'){
      //   const fteMin = child.data?.cost_min;
      //   if(fteMin === null || fteMin === undefined || isNaN(fteMin) || typeof fteMin !== 'number'){
      //     child.error = 'InvalidFteMin'
      //     this.cdr.detectChanges()
      //     this.validateAllEntitysErrors = 'InvalidFteMin'
      //   }
      // }
      // if(child.data?.type == 'persona' && !child.parent){
      //   child.error = 'PersonaWithoutOrganogram'
      //   this.cdr.detectChanges()
      //   this.validateAllEntitysErrors = 'PersonaWithoutOrganogram'
      // }

      const siblings = children.filter((sibling: any) => sibling.label === child.label && sibling.uuid !== child.uuid)
      if(siblings?.length > 0){
        child.error = 'SameNameElement'
        this.cdr.detectChanges()
        this.validateAllEntitysErrors = 'SameNameElement'
      }

      if(child.children && child.children?.length > 0){
        await this.validateAllEntitys(child.children)
      }
    }
  }

  async saveTree(isNew: boolean = true) {
    const getNextCodeSuffix = (siblings: any[]) => {
      const usedSuffixes = siblings
        .map(child => {
          const codeParts = (child.code || '').split('.');
          const last = codeParts[codeParts.length - 1];
          return parseInt(last, 10);
        })
        .filter(num => !isNaN(num));
  
      let next = 5;
      while (usedSuffixes.includes(next)) {
        next += 5;
      }
      return next.toString().padStart(2, '0');
    };
  
    const assignCodesRecursively = (nodes: any[], parentCode: string = '') => {
      nodes.sort((a, b) => a.label.localeCompare(b.label, 'pt-BR', { numeric: true }));
  
      for (let i = 0; i < nodes.length; i++) {
        const node = nodes[i];
  
        // Determina o próximo sufixo válido para esse nível
        const nextSuffix = getNextCodeSuffix(nodes.slice(0, i));
        node.code = parentCode ? `${parentCode}.${nextSuffix}` : nextSuffix;
  
        // Recursão nos filhos
        if (node.children && node.children.length > 0) {
          assignCodesRecursively(node.children, node.code);
        }
      }
    };
  
    // valida antes de salvar
    await this.validateAllEntitys(this.files);
    this.cdr.detectChanges();
    
    if (this.validateAllEntitysErrors) {
      addAlert('orange', this.getLanguages('errors/personas/' + this.validateAllEntitysErrors));
      this.validateAllEntitysErrors = '';
      return;
    }
  
    // atribui os códigos à árvore inteira
    assignCodesRecursively(this.files);

    // monta o formData
    const newFormData = new FormData();
    for (const pair of this.formData.entries()) {
      if (pair[0] !== 'json') {
        newFormData.append(pair[0], pair[1]);
      }
    }

    if (Array.isArray(this.files)) {
      this.files.forEach(item => this.removeParentReferences(item));
    }

    newFormData.append('json', stringify(this.files));
    this.formData = newFormData;
  
    this.isEdited = false;
    this.isLoading = true;
    this.isShow = false;
    this.isShowEdit = false;
    delete this.selectedFile;
    try {
      const response: any = await this.personasService.setPersonasTree(this.formData, this.personas.uuid);
      if ([201, 202].includes(response.status)) {
        addAlert('success', response.message);
        await this.getPersonasTree();
        this.flagImportedTree = false;
      } else {
        addAlert('danger', response.message);
      }
    } catch (error: any) {
      await apiOfflineAsync(error);
    } finally {
      this.isLoading = false;
    }
  }
  

  // async setFormData() {
  //   this.formData = new FormData()
  //   this.formData.append('json', stringify(this.filesOld))
  // }

  isResponsive(): boolean {
    return window.innerWidth >= 900;
  }

  removeParentReferences(node: any) {
    if (node && typeof node === 'object') {
      delete node.parent;
      if (Array.isArray(node.children)) {
        node.children.forEach((child: any) => this.removeParentReferences(child));
      }
    }
  }

  getParentCount(node: any): number {
    let parentCount = 0;
    let parentNode = node;

    while (parentNode && parentNode.parent) {
      parentCount++;
      parentNode = parentNode.parent;
    }

    // Adicione 1 para incluir o próprio nó na contagem
    return parentCount + 1;
  }

  async getTreeXls(type: string = '') {
    this.isLoading = true;
    try {
      const response: Blob = await this.personasService.getTreeXls({
        environment: this.properties.environment,
        corporation: this.properties.corporation,
        json: type == 'json',
        xls: type == 'xls'
      });

      await this.personasService.downloadJsonXls(response, `${this.properties?.corporation?.slug}-persona-tree`, type)
      addAlert('success', this.getLanguages('businessSolution/top/info/export/success'))

    } catch (error: any) {
      await apiOfflineAsync(error)
    }
    this.isLoading = false;
  }

  getIcon(slug: string): string {
    let icon: string = ''

    switch (slug) {
      case 'persona':
        icon = 'fa-user-tie'
        break;
      case 'organogram':
        icon = 'fa-sitemap'
        break;
      case 'organization':
        icon = 'fa-building'
        break;
      default:
        break;
    }

    return icon
  }
}


